import { IReportReenrollmentState } from '../interfaces/ireport-reenrollment-status';

export const REPORT_REENROLLMENT_STATE: IReportReenrollmentState = {
    tokenData: '',
    active: false
};
